import {repository} from 'aurelia-orm';
import { ItemTypeBase } from "./item-type-base";

@repository('itemstatus')
export class ItemStatus extends ItemTypeBase {
	itemStatusTypeId: number;
}